import { Card, Skeleton, Space } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ConfirmAndContinueButton from '../../../components/buttons/ConfirmAndContinueButton';
import PreviousButton from '../../../components/buttons/PreviousButton';
import ServiceAreaDataTable from '../../../components/datatables/secondary/ServiceAreaDataTable';
import DataReviewLayout from '../../../components/secondary/DataReviewLayout';
import Breadcrumbs from '../../../config/Breadcrumbs';
import Routes from '../../../config/Routes';
import HistoryUtil from '../../../utils/HistoryUtil';
import ParameterUtil from '../../../utils/ParameterUtil';

interface ServiceAreaListPageState {
  academicYear: number;
}

interface ServiceAreaListPageProps {
}

class DataReviewServiceAreaListPage extends React.Component<ServiceAreaListPageProps & RouteComponentProps<RouteObject>, ServiceAreaListPageState> {

  constructor(props: ServiceAreaListPageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      academicYear: 0,
    };
  }

  componentDidMount() {
    const year = Number.parseInt(ParameterUtil.getPathPart(this.props.match, 'academicYearId'));

    if (this.state.academicYear != year) {
      this.setState({ academicYear: year });
    }
  }

  private onBack = () => {
    HistoryUtil.push(Routes.generate(Routes.DATA_REVIEW_AREA_EDUCATION_AGENCY, { academicYearId: this.state.academicYear }, {}));
  }

  private onContinue = () => {
    HistoryUtil.push(Routes.generate(Routes.DATA_REVIEW_FEDERAL_CLUSTERS, { academicYearId: this.state.academicYear }, {}));
  }

  render() {
    const academicYear = this.state.academicYear == 0 ? 0 : this.state.academicYear;

    if (academicYear != 0) {
      return (
        <Content >
          <DataReviewLayout breadcrumbs={Breadcrumbs.academicYearDataReview(academicYear)} stepNumber={1} academicYear={academicYear}>
            <Card title="Service Areas">
              <Space direction='vertical' size="middle">
                <ServiceAreaDataTable academicYear={this.state.academicYear} />
                <Space>
                  <PreviousButton onClick={this.onBack} />
                  <ConfirmAndContinueButton onClick={this.onContinue} />
                </Space>
              </Space>
            </Card>
          </DataReviewLayout>
        </Content>
      );
    }

    return <Skeleton />;
  }
}

export default withRouter((DataReviewServiceAreaListPage));
